import type { SxProps, Theme } from '@mui/material';

/**
 * Switch styled to match the brush-size slider in the same toolbar row: a
 * flat pill track (translucent off, primary on) with a white 12px thumb.
 */
export const sliderSwitchSx: SxProps<Theme> = {
    width: 30,
    height: 14,
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: '1px',
        transitionDuration: '150ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: 'primary.main',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 12,
        height: 12,
        backgroundColor: '#fff',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.4)',
    },
    '& .MuiSwitch-track': {
        borderRadius: 100,
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        opacity: 1,
    },
};

/** Shared text styling for the constraint popover row labels. */
export const labelSx = {
    fontSize: 12,
    color: 'rgba(255, 255, 255, 0.85)',
    userSelect: 'none',
} as const;

/** Styling for an inline "constraint enabled but inactive" warning. */
export const warningSx = {
    fontSize: 11,
    color: 'warning.main',
    mt: 0.5,
} as const;

/**
 * Styling for a muted "doesn't apply in this mode" note (e.g. Inside/Outside
 * shown while erasing). Dimmed rather than colored — it is informational, not a
 * problem the user needs to fix.
 */
export const mutedNoteSx = {
    fontSize: 11,
    color: 'rgba(255, 255, 255, 0.5)',
    mt: 0.5,
} as const;

/** Divider separating the constraint sections in the popover. */
export const sectionDividerSx = {
    my: 1,
    borderColor: 'rgba(255, 255, 255, 0.15)',
} as const;
